import React from 'react';
import moment from 'moment';
import 'moment/locale/cs';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import PostReactions from './PostReactions';
import PostComments from "./PostComments";
import 'react-photo-view/dist/react-photo-view.css';
import EchoUsername from './EchoUsername';
import { formatTextWithLinks } from "../utils/formatText";
import {useNavigate} from "react-router-dom";
import { Dropdown } from 'react-bootstrap';
import {useState} from "react";
import Swal from 'sweetalert2';
import EditPostModal from './EditPostModal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const fullUrl = (path) => {
    if (!path) return null;
    return path.startsWith('http') ? path : `https://fantasyworldtrpg.cz${path}`;
};

const fullUrlEcho = (path) => {
    if (!path) return null;
    return path.startsWith('http') ? path : `https://echo.fantasyworldtrpg.cz${path}`;
};

const Post = ({ post, onlineUsers }) => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAdultContent, setShowAdultContent] = useState(false);

    const handleToggleComments = () => {
        const action = post.locked === 1 ? 'povolit' : 'vypnout';
        Swal.fire({
            title: `${action.charAt(0).toUpperCase() + action.slice(1)} komentáře?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#aaa',
            confirmButtonText: `Ano, ${action}`,
            cancelButtonText: 'Zrušit'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await fetch(`https://api.fantasyworldtrpg.cz/echo/toggle_comments.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        postId: post.id,
                        u: localStorage.getItem("fw_user_lvl")
                    }),
                });

                const res = await response.json();
                if (res.success) {
                    Swal.fire(
                        'Hotovo!',
                        res.locked === 1 ? 'Komentáře byly vypnuty.' : 'Komentáře byly povoleny.',
                        'success'
                    ).then(() => {
                        window.location.reload();
                    });
                } else {
                    Swal.fire('Chyba', res.message || 'Nepodařilo se přepnout komentáře.', 'error');
                }
            }
        });
    };

    const handleToggleAdult = () => {
        const action = post.adult == 1 ? 'odznačit jako citlivý' : 'označit jako citlivý obsah';
        Swal.fire({
            title: `Opravdu chceš ${action}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#aaa',
            confirmButtonText: `Ano, ${action}`,
            cancelButtonText: 'Zrušit'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await fetch(`https://api.fantasyworldtrpg.cz/echo/toggle_adult.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        postId: post.id,
                        u: localStorage.getItem("fw_user_lvl")
                    }),
                });

                const res = await response.json();
                if (res.success) {
                    Swal.fire(
                        'Hotovo!',
                        res.adult === 1 ? 'Příspěvek je nyní označen jako citlivý.' : 'Citlivost byla odstraněna.',
                        'success'
                    ).then(() => {
                        window.location.reload();
                    });
                } else {
                    Swal.fire('Chyba', res.message || 'Nepodařilo se přepnout citlivost.', 'error');
                }
            }
        });
    };

    const handlePin = () => {
        const action = post.pin == 1 ? 'odepnout' : 'připnout';
        Swal.fire({
            title: `Opravdu chceš ${action}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#aaa',
            confirmButtonText: `Ano, ${action}`,
            cancelButtonText: 'Zrušit'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await fetch(`https://api.fantasyworldtrpg.cz/echo/toggle_pin.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        postId: post.id,
                        u: localStorage.getItem("fw_user_lvl"),
                        c: localStorage.getItem("echo_user")
                    }),
                });

                const res = await response.json();
                if (res.success) {
                    Swal.fire(
                        'Hotovo!',
                        res.adult === 1 ? 'Příspěvek je nyní připnutý.' : 'Příspěvek byl odepnut.',
                        'success'
                    ).then(() => {
                        window.location.reload();
                    });
                } else {
                    Swal.fire('Chyba', res.message || 'Nepodařilo se přepnout pin.', 'error');
                }
            }
        });
    };

    const handleDelete = () => {
        Swal.fire({
            title: 'Smazat příspěvek?',
            text: "Tuto akci nelze vrátit zpět!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ano, smazat!',
            cancelButtonText: 'Zrušit'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await fetch(`https://api.fantasyworldtrpg.cz/echo/delete_post.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        postId: post.id,
                        userId: localStorage.getItem("echo_user"),
                        u: localStorage.getItem("fw_user"),
                    }),
                });

                const result = await response.json();

                if (result.success) {
                    Swal.fire(
                        'Smazáno!',
                        'Příspěvek byl úspěšně smazán.',
                        'success'
                    ).then(() => {
                        window.location.reload();
                    });
                } else {
                    Swal.fire(
                        'Chyba!',
                        result.message || 'Nepodařilo se smazat příspěvek.',
                        'error'
                    );
                }
            }
        });
    };


    const date = moment(post.dt).format('D. M. YYYY, HH:mm');
    const contentClass = post.image ? 'text-center' : '';

    const navigate = useNavigate();
    const frameType = post.vip_frame ? post.vip_frame : null;


    return (
        <div className="border rounded p-3 mb-3 shadow-sm post">
            <div className="d-flex align-items-center mb-2">
                <div className={`rounded-circle me-2 ${frameType ? `vip-frame-${frameType}-little` : ''}`} style={{width: '40px', height: '40px', position: 'relative', overflow: 'hidden'}}>
                    <img
                        onClick={() => navigate(`/profile/${post.user}`)}
                        src={fullUrl(post.avatar)}
                        alt="avatar"
                        className="rounded-circle"
                        style={{width: '100%', height: '100%', objectFit: 'cover', cursor: 'pointer', position: 'relative', zIndex: 2}}
                    />
                </div>

                <div>
                    <EchoUsername userId={post.user} name={post.author} accountType={post.account_type} onlineUsers={onlineUsers}></EchoUsername>{(post.activity && ` se cítí ${post.activity.toLowerCase()}`)}{(post.system_info && ` ${post.system_info}`)}<br/>
                    <small style={{cursor: "pointer"}} onClick={() => navigate(`/post/${post.id}`)} className="text-gray">{date}</small> {(post.pin == 1 && (<b className="ms-2 text-secondary">📍 PŘIPNUTO</b>))}
                </div>

                {(localStorage.getItem("fw_user_lvl") > 1 || localStorage.getItem("echo_user") === post.user) && (
                    <Dropdown className="ms-auto">
                        <Dropdown.Toggle variant="secondary" size="sm" style={{ border: 'none' }}>
                            ⋮
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item onClick={handleDelete} className="text-danger">
                                🗑️ Smazat příspěvek
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setShowEditModal(true)}>
                                ✏️ Upravit příspěvek
                            </Dropdown.Item>
                            <Dropdown.Item onClick={handleToggleComments}>
                                {post.locked == 1 ? '💬 Povolit komentáře' : '🚫 Vypnout komentáře'}
                            </Dropdown.Item>
                            {localStorage.getItem("fw_user_lvl") > 1 && (
                                <>
                                    <Dropdown.Item onClick={handleToggleAdult}>
                                        {post.adult == 1 ? '🔓 Odznačit jako citlivý' : '🔒 Označit jako citlivý'}
                                    </Dropdown.Item>
                                </>
                            )}
                            <Dropdown.Item onClick={handlePin}>
                                {post.pin == 1 ? '📍 Odepnout' : '📍 Připnout'}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                )}

            </div>
            <hr/>
            <EditPostModal
                show={showEditModal}
                handleClose={() => setShowEditModal(false)}
                post={post}
                onSave={() => window.location.reload()}
            />


            {post.adult == 1 && !showAdultContent ? (
                    <div
                        className="blurred-content p-3 rounded text-center"
                        style={{
                            background: 'rgba(0,0,0,0.05)',
                            backdropFilter: 'blur(5px)',
                            cursor: 'pointer'
                        }}
                        onClick={() => setShowAdultContent(true)}
                    >
                        <div className="text-secondary">⚠️ Tento příspěvek byl označen jako citlivý. Klikni pro zobrazení.</div>
                    </div>
                ) : (
                    <div className={contentClass}>
                        {post.text && <p>{formatTextWithLinks(post.text, 1)}</p>}
                        {post.images ? (
                            <PhotoProvider>
                                <Swiper
                                    spaceBetween={10}
                                    slidesPerView={1}
                                    pagination={{
                                        type: 'fraction',
                                        clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    style={{ maxWidth: '100%', maxHeight: '400px', borderRadius: '10px', position: 'relative' }}
                                >
                                    {(() => {
                                        try {
                                            const imagesArray = typeof post.images === 'string' ? JSON.parse(post.images) : post.images;
                                            return Array.isArray(imagesArray) ? imagesArray.map((img, index) => (
                                                <SwiperSlide key={index}>
                                                    <PhotoView src={img.startsWith('http') ? img : fullUrlEcho(img)}>
                                                        <img
                                                            loading="lazy"
                                                            src={img.startsWith('http') ? img : fullUrlEcho(img)}
                                                            alt={`Příspěvek ${index + 1}`}
                                                            className="img-fluid rounded shadow-sm mt-2"
                                                            style={{ width: '100%', maxHeight: '400px', objectFit: 'contain', cursor: 'pointer', backgroundColor: 'transparent' }}
                                                        />
                                                    </PhotoView>
                                                </SwiperSlide>
                                            )) : null;
                                        } catch (error) {
                                            return null;
                                        }
                                    })()}
                                </Swiper>
                            </PhotoProvider>
                        ) : post.image && (
                            <PhotoProvider>
                                <PhotoView src={fullUrlEcho(post.image)}>
                                    <img
                                        loading="lazy"
                                        src={fullUrlEcho(post.image)}
                                        alt="Příspěvek"
                                        className="img-fluid rounded shadow-sm mt-2"
                                        style={{ width: '100%', maxHeight: '400px', objectFit: 'contain', cursor: 'pointer' }}
                                    />
                                </PhotoView>
                            </PhotoProvider>
                        )}
                    </div>
                )}
                <div className="mt-3 tag-wrap">
                {(() => {
                    try {
                        const tags = JSON.parse(post.tag);
                        return Array.isArray(tags)
                            ? tags.map((tag, index) => (
                                <span key={index} className="tag lead me-1">#{tag}</span>
                            ))
                            : null;
                    } catch (e) {
                        return null;
                    }
                })()}
            </div>
            <PostReactions postId={post.id} aiLikeCount={post.ai_like_current} aiHeartCount={post.ai_like_h_current} />
            <PostComments post={post} />
        </div>
    );
};

export default Post;
